import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=c2b8f346&"
import script from "./DefaultView.vue?vue&type=script&lang=ts&"
export * from "./DefaultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports